<div *ngIf="!submitted; else apiResponseContainer" class="d-flex flex-row">
  <input type="file" #file multiple (change)="addFile()"/>
  <div class="files-names-cont">
    <div *ngIf="selectedFiles.size === 0; else filesNamesCont">{{'NO_FILE_CHOSEN' | translate}}</div>
    <ng-template #filesNamesCont>
      <ul>
        <li *ngFor="let file of selectedFiles">{{file.name}}</li>
      </ul>
    </ng-template>
  </div>
  <div class="buttons-cont">
    <div class="m-auto d-flex flex-column">
      <button class="btn btn-outline-info" (click)="openUnit()">{{ 'SHOW_UNITS' | translate }}</button>
      <button class="btn btn-outline-dark" (click)="file.click()">{{'CHOOSE_FILES' | translate}}</button>
      <button class="btn btn-info" (click)="postCSVFiles()">{{ 'SAVE' | translate }}</button>
    </div>
  </div>
</div>

<ng-template #apiResponseContainer>
  <div class="apiReportSection success">
    <fa-icon [icon]="faCheckCircle"></fa-icon>
    {{ 'CREATED_DEVICES' | translate }}: {{createdDevice}}
  </div>
  <div class="apiReportSection errors" *ngIf="isAtLeastOneError">
    <fa-icon [icon]="faTimesCircle"></fa-icon>
    {{ 'ERRORS' | translate }}:
    <ul *ngFor="let apiResponse of apiResponses">
      <li *ngIf="apiResponse.errors || apiResponse.fileIssue">{{'FILE' | translate}} "{{apiResponse.fileName}}":
        <ul>
          <li *ngIf="apiResponse.fileIssue">{{apiResponse.fileIssue | translate}}</li>
          <li *ngFor="let error of apiResponse.errors">{{ 'LINE' | translate }} {{error.line}}
            : {{error.message}}
            <ul *ngIf="error.errors">
              <li *ngFor="let subError of getArray(error.errors)">{{'COLUMN' | translate}} {{subError[0]}}
                : {{subError[1]}}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
  <button class="btn btn-info" (click)="newImport()">{{'NEW_IMPORT' | translate}}</button>
  <button class="btn btn-light" (click)="quit.emit()">{{'CLOSE' | translate}}</button>
</ng-template>
